import { useTranslation } from 'react-i18next';
import i18n from '../../i18n';

export default function LangToggle() {
  const { i18n: i18nInst } = useTranslation();
  const current = i18nInst.language;

  function toggle(lang) {
    i18n.changeLanguage(lang);
    localStorage.setItem('lang', lang);
  }

  return (
    <div className="flex items-center gap-0.5 bg-gray-100 rounded-lg p-0.5 text-xs font-semibold">
      <button
        onClick={() => toggle('bn')}
        className={`px-2.5 py-1 rounded-md transition-colors ${current === 'bn' ? 'bg-white text-violet-600 shadow-sm' : 'text-gray-400 hover:text-gray-600'}`}
      >
        বাং
      </button>
      <button
        onClick={() => toggle('en')}
        className={`px-2.5 py-1 rounded-md transition-colors ${current === 'en' ? 'bg-white text-violet-600 shadow-sm' : 'text-gray-400 hover:text-gray-600'}`}
      >
        EN
      </button>
    </div>
  );
}
